import { initAlpinejs } from './modules/alpinejs';
import { initSwiper } from './modules/swiper';

document.addEventListener('DOMContentLoaded', function () {
  initAlpinejs();
  initSwiper();
});
